import apiConfig from "@/config/api.config";
import axios from "axios";
import { responseInterceptor } from "../http/interceptors";
import { identityRequestInterceptor } from "@/services/apis/identity/identity.interceptors";

/**
 * Create Service client
 * @public
 */
export const $service = axios.create({
  baseURL: apiConfig.SERVICE_APP_BASE_URL,
});

$service.interceptors.request.use(identityRequestInterceptor);

$service.interceptors.response.use(undefined, responseInterceptor);
